import { styled, theme } from "@theme/stitches.config"

export const StickySidebar = styled("aside", {
    position: "sticky",
    top: 200,
    "@lgDown": {
        top: 120
    }
})

export const LeftArticleColumn = styled("div", {
    width: "33.3333%",
    flex: "1 0 33.3333%",
    paddingRight: 70,
    "& p": {
        fontSize: theme.fontSizes.desktopLarge,
        textTransform: "uppercase",
        fontFamily: theme.fonts.heading,
        mb: 16
    },
    ul: {
        m: 0,
        p: 0,
        pl: 20,
        li: {
            py: 2,
            button: {
                p: 0,
                m: 0,
                textAlign: "left",
                appearance: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "white",
                lineHeight: 1.25,
                fontSize: theme.fontSizes.desktopBody,
                fontWeight: theme.fontWeights.bold,
                fontFamily: theme.fonts.body
            }
        }
    },
    "@mdDown": {
        display: "none"
    }
})

export const ArticleWrapper = styled("div", {
    [`${LeftArticleColumn} p, a`]: {
        color: theme.colors.R500
    },
    variants: {
        background: {
            red: {
                background: "linear-gradient(224.04deg, rgba(255, 0, 0, 0.8) 24.34%, #B9271C 50.31%)",
                [`${LeftArticleColumn} p`]: {
                    color: theme.colors.white
                },
                a: {
                    color: theme.colors.white,
                    textDecoration: "underline"
                }
            }
        }
    }
})

export const ArticleContainer = styled("div", {
    width: 1240,
    maxWidth: "calc(100% - 200px)",
    mx: "auto",
    pt: 144,
    pb: 120,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "@lgDown": {
        maxWidth: "calc(100% - 100px)"
    },
    "@mdDown": {
        pt: 60,
        maxWidth: "calc(100% - 40px)"
    }
})

export const RightArticleColumn = styled("div", {
    width: "66.6666%",
    flex: "1 0 66.6666%",
    "h1, h2": {
        fontSize: theme.fontSizes.desktopH5
    },
    "h3, h4, h5, h6": {
        fontSize: theme.fontSizes.desktopH6
    },
    "& > div:not(:last-child)": {
        mb: 80,
        "@mdDown": {
            mb: 40
        }
    },
    "& img": {
        maxWidth: "100%",
        height: "auto",
        mt: 16,
        "@mdDown": {
            mt: 0
        }
    },
    "& a": {
        color: theme.colors.R500
    },
    "@mdDown": {
        width: "100%",
        flex: "1 0 100%"
    }
})
